module.exports = __webpack_public_path__ + "fonts/564c19e17b2494d52827865fb622bc72.svg";